/**
 * A global namespace for `dragenter` event.
 */
const dragenterEvent = "dragenter";
export default dragenterEvent;
